import React from 'react';
import {Col, Row} from 'antd';
import Filter from '../filter';
import MainChart from '../chart';

export class Audit extends React.Component {
  renderGraphic(m, colSpan) {
    const {
      groups, labelType, labelValues, initialState, setInitialState,
      projects, osGroups, browserGroups, trafficChannels, affiliateNetworks, deviceTypes, country, cities, region
    } = this.props;
    let {dateFrom, dateTo} = this.props;
    dateFrom = dateFrom.utcOffset(0, true);
    dateTo = dateTo.utcOffset(0, true);
    return (
      <Col style={{minWidth: '400px'}} span={colSpan} key={m}>
        <MainChart
          initialState={initialState[m]}
          setInitialState={setInitialState}
          metric={m}
          dateFrom={dateFrom} dateTo={dateTo}
          units={['percent','count']}
          groups={groups}
          osGroups={osGroups}
          browserGroups={browserGroups}
          trafficChannels={trafficChannels}
          affiliateNetworks={affiliateNetworks}
          deviceTypes={deviceTypes}
          country={country}
          cities={cities}
          region={region}
          projects={projects}
          labelType={labelType}
          labelValues={labelValues}
        />
      </Col>
    )
  }

  renderGraphics() {
    return (
      <div>
        <Row gutter={8} style={{marginTop: '8px'}} className={'charts-row'}>
          {this.renderGraphic('lead-age', 12)}
          {this.renderGraphic('lead-duration', 12)}
        </Row>
        <Row gutter={8} style={{marginTop: '8px'}} className={'charts-row'}>
          {this.renderGraphic('consumer-origin-by-ip', 12)}
          {this.renderGraphic('consumer-origin-by-device', 12)}
        </Row>
        <Row gutter={8} style={{marginTop: '8px'}} className={'charts-row'}>
          {this.renderGraphic('lead-closure', 12)}
          {this.renderGraphic('lead-closure-relative', 12)}
        </Row>
        {/* <Row gutter={8} style={{marginTop: '8px'}} className={'charts-row'}>
          {this.renderGraphic('lead-lineage-other', 12)}
          {this.renderGraphic('lead-lineage-you', 12)}
        </Row> */}
        <Row gutter={8} style={{marginTop: '8px'}} className={'charts-row'}>
          {this.renderGraphic('lead-browsers-desktop', 12)}
          {this.renderGraphic('lead-browsers-mobile', 12)}
        </Row>
        <Row gutter={8} style={{marginTop: '8px'}} className={'charts-row'}>
          {this.renderGraphic('lead-os-desktop', 12)}
          {this.renderGraphic('lead-os-mobile', 12)}
        </Row>
        <Row gutter={8} style={{marginTop: '8px'}} className={'charts-row'}>
          {this.renderGraphic('lead-device-types', 12)}
        </Row>
      </div>
    )
  }

  render() {
    const {
      metric, dateFrom, dateTo, groups, labelType, labelValues, dateSelector, region,
      osGroups, browserGroups, trafficChannels, affiliateNetworks, deviceTypes, country, cities
    } = this.props;
    return (<div className='page'>
      <Filter
        period={[dateFrom, dateTo]}
        onPeriodChange={this.props.onPeriodChange}
        metrics={[]}
        metric={metric}
        onMetricChange={this.props.onMetricChange}
        selected={groups}
        osGroupsSelected={osGroups}
        browserGroupsSelected={browserGroups}
        trafficChannelsSelected={trafficChannels}
        affiliateNetworksSelected={affiliateNetworks}
        deviceTypesSelected={deviceTypes}
        countrySelected={country}
        regionsSelected={region}
        citiesSelected={cities}
        onLeadGroupsChange={this.props.onLeadGroupsChange}
        onOsGroupsChange={this.props.onOsGroupsChange}
        onBrowserGroupsChange={this.props.onBrowserGroupsChange}
        onTrafficChannelsChange={this.props.onTrafficChannelsChange}
        onAffiliateNetworksChange={this.props.onAffiliateNetworksChange}
        onDeviceTypesChange={this.props.onDeviceTypesChange}
        onCountryChange={this.props.onCountryChange}
        onRegionChange={this.props.onRegionChange}
        onCitiesChange={this.props.onCitiesChange}
        onUrlLabelsChange={this.props.onUrlLabelsChange}
        labelType={labelType}
        labelValues={labelValues}
        dateSelector={dateSelector}
      />
      {this.renderGraphics()}
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/audit/index.js